const LOW_OCCUPANCY_LEVEL = [1, 2]
const HALF_OCCUPANCY_LEVEL = [3]
const HIGH_OCCUPANCY_LEVEL = [4, 5]

function hasLowOccupancyLevel(bus = {}) {
  const occupancy_level = bus.occupancy_level || bus.bus_occupancy_level
  return LOW_OCCUPANCY_LEVEL.includes(occupancy_level)
}

function hasHalfOccupancyLevel(bus = {}) {
  const occupancy_level = bus.occupancy_level || bus.bus_occupancy_level
  return HALF_OCCUPANCY_LEVEL.includes(occupancy_level)
}

function hasHighOccupancyLevel(bus = {}) {
  const occupancy_level = bus.occupancy_level || bus.bus_occupancy_level
  return HIGH_OCCUPANCY_LEVEL.includes(occupancy_level)
}

function hasOccupancyLevel(bus = {}) {
  const occupancy_level = bus.occupancy_level || bus.bus_occupancy_level
  return (
    LOW_OCCUPANCY_LEVEL + HALF_OCCUPANCY_LEVEL + HIGH_OCCUPANCY_LEVEL
  ).includes(occupancy_level)
}

function occupancyTranslation(bus = {}) {
  const occupancy_level = bus.occupancy_level || bus.bus_occupancy_level
  if (occupancy_level) return Vue.i18n.t(`positionBusIconRules.occupancy.${occupancy_level}`)
  return undefined
}

function getOccupancyLevelClass(bus = {}) {
  switch (true) {
    case (hasLowOccupancyLevel(bus)):
      return 'low-occupancy'
    case (hasHalfOccupancyLevel(bus)):
      return 'half-occupancy'
    case (hasHighOccupancyLevel(bus)):
      return 'high-occupancy'
    default:
      return undefined
  }
}

function occupancyImg(bus = {}) {
  const imgName = getOccupancyLevelClass(bus)
  if (imgName) {
    return require(`assets/images/map/${imgName}.svg`)
  }
  return undefined
}

function accessibleTranslation() {
  return Vue.i18n.t('positionBusIconRules.accessible')
}

function sanitizedTranslation() {
  return Vue.i18n.t('positionBusIconRules.sanitized')
}

function isSanitized(bus = {}) {
  const sanitized = bus.sanitized || bus.bus_sanitized
  return sanitized === true
}

function isAccessible(bus = {}) {
  const accessible = bus.wheelchair_accessible || bus.bus_wheelchair_accessible || bus.accessible
  return accessible === 1
}

function isNorthEastOrientation(bus = {}) {
  return bus.orientation > 22.5 && bus.orientation <= 67.5
}

function isEastOrientation(bus = {}) {
  return bus.orientation > 67.5 && bus.orientation <= 112.5
}

function isSouthEastOrientation(bus = {}) {
  return bus.orientation > 112.5 && bus.orientation <= 147.5
}

function isSouthOrientation(bus = {}) {
  return bus.orientation > 147.5 && bus.orientation <= 202.5
}

function isSouthWestOrientation(bus = {}) {
  return bus.orientation > 202.5 && bus.orientation <= 247.5
}

function isWestOrientation(bus = {}) {
  return bus.orientation > 247.5 && bus.orientation <= 292.5
}

function isNorthWestOrientation(bus = {}) {
  return bus.orientation > 292.5 && bus.orientation <= 337.5
}

function isNorthOrientation(bus = {}) {
  return bus.orientation > 337.5 || bus.orientation <= 22.5
}

function getSanitizedClass(bus = {}) {
  if (isSanitized(bus)) return 'sanitized'
  return undefined
}

function getAccessibleClass(bus = {}) {
  if (isAccessible(bus)) return 'accessible'
  return undefined
}

function getOrientationClass(bus = {}) {
  switch (true) {
    case (isNorthEastOrientation(bus)):
      return 'northeast'
    case (isEastOrientation(bus)):
      return 'east'
    case (isSouthEastOrientation(bus)):
      return 'southeast'
    case (isSouthOrientation(bus)):
      return 'south'
    case (isSouthWestOrientation(bus)):
      return 'southwest'
    case (isWestOrientation(bus)):
      return 'west'
    case (isNorthWestOrientation(bus)):
      return 'northwest'
    case (isNorthOrientation(bus)):
      return 'north'
    default:
      return undefined
  }
}

export default {
  mapIconClasses(bus = {}) {
    const occupancyLevelClass = getOccupancyLevelClass(bus)
    const sanitizedClass = getSanitizedClass(bus)
    const wheelchairAccessibleClass = getAccessibleClass(bus)
    const orientationClass = getOrientationClass(bus)

    let classes = ''
    if (occupancyLevelClass) classes += ` ${occupancyLevelClass}`
    if (sanitizedClass) classes += ` ${sanitizedClass}`
    if (wheelchairAccessibleClass) classes += ` ${wheelchairAccessibleClass}`
    if (orientationClass) classes += ` ${orientationClass}`
    return classes
  },
  isAccessible,
  isSanitized,
  hasLowOccupancyLevel,
  hasHalfOccupancyLevel,
  hasHighOccupancyLevel,
  hasOccupancyLevel,
  occupancyImg,
  occupancyTranslation,
  accessibleTranslation,
  sanitizedTranslation,
  isNorthEastOrientation,
  isEastOrientation,
  isSouthEastOrientation,
  isSouthOrientation,
  isSouthWestOrientation,
  isWestOrientation,
  isNorthWestOrientation,
  isNorthOrientation
}
